import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';

import { UpdateCommunicationLanguage } from '../actions/communication-language.actions';

@Injectable({ providedIn: 'root' })
export class CommunicationLanguageStoreService {
  @Dispatch()
  updateCommunicationLanguage = (language: string) =>
    new UpdateCommunicationLanguage(language);
}
